const tr = {
    en: {
        title: "One moment...",
        loadingReminder: "Please don''t click back, refresh or close this page while we process payment. Thanks!",
    },
    zh: {
        title: "請稍候…",
        loadingReminder: "付款處理中，請勿點擊返回、刷新或關閉此頁面。謝謝！",
    }
}

export default tr;
